function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.79971 3.20026C3.91571 3.20026 3.19971 3.91626 3.19971 4.80026V19.2003C3.19971 20.0843 3.91571 20.8003 4.79971 20.8003H19.1997C20.0837 20.8003 20.7997 20.0843 20.7997 19.2003V4.80026C20.7997 3.91626 20.0837 3.20026 19.1997 3.20026H4.79971ZM11.1997 6.40026H12.7997C13.2413 6.40026 13.5997 6.75866 13.5997 7.20026V10.4003H16.7997C17.2413 10.4003 17.5997 10.7587 17.5997 11.2003V12.8003C17.5997 13.2419 17.2413 13.6003 16.7997 13.6003H13.5997V16.8003C13.5997 17.2419 13.2413 17.6003 12.7997 17.6003H11.1997C10.7581 17.6003 10.3997 17.2419 10.3997 16.8003V13.6003H7.19971C6.75811 13.6003 6.39971 13.2419 6.39971 12.8003V11.2003C6.39971 10.7587 6.75811 10.4003 7.19971 10.4003H10.3997V7.20026C10.3997 6.75866 10.7581 6.40026 11.1997 6.40026Z",
  fill: "#342B75"
});

var SvgHospital = function SvgHospital(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHospital, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hospital.4d47e5ad.svg";
export { ForwardRef as ReactComponent };